import styled, { Layout, ResponsiveTypography, Scale, StyledComponent } from '@se-admin/falcon';

export const CustomLayoutWrapper: StyledComponent<typeof Layout.Wrapper, {}, {}> = styled(
  Layout.Wrapper
)`
  && {
    display: inline;
    margin-left: ${Scale.xxs};
  }
`;

export const CustomTypography: StyledComponent<typeof ResponsiveTypography, {}, {}> = styled(
  ResponsiveTypography
)`
  display: inline;
  vertical-align: text-bottom;
`;

export const LeadRateContainer: StyledComponent<'div', {}, {}> = styled('div')`
display: flex;
align-items: center;
font-size: 0;
}
`;
